<div class="close-button">
  <button class="clear-transparent" mat-dialog-close>
    <span class="icon-close"></span>
  </button>
</div>
<mat-dialog-content class="mat-typography">
  <div class="well mb-3 text-center">
    <h3>Mohon Perhatian</h3>
    <p>
      Untuk meningkatkan keamanan transaksi Anda, sistem kami secara otomatis
      menonaktifkan fitur penarikan dana jika terdeteksi adanya perubahan pada
      data rekening atau data diri Anda. Fitur penarikan akan aktif kembali
      setelah data Anda disetujui oleh admin.
    </p>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <ng-container>
    <button mat-dialog-close mat-button class="primary-button big-button mb-2">
      Tutup
    </button>
  </ng-container>
</mat-dialog-actions>
